import React from 'react'

import { Provider } from 'react-redux'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Helmet } from 'react-helmet'
import { withPrefix } from 'gatsby'

import { initTheme, Theme } from '@interco/inter-ui'
import { SnackBarProvider } from '@interco/inter-ui/components/SnackBar'

import createStore from './src/store/createStore'

import '@interco/inter-ui/inter-ui.css'
import './bootstrap.scss'

export default ({ element }) => {
  const store = createStore()

  initTheme(Theme.PF)
  return (
    <Provider store={store}>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA} useEnterprise>
        <SnackBarProvider>
          <Helmet>
            <html lang="pt-BR" />
            <title>Antecipação FGTS</title>
            <meta name="googlebot" content="noindex" />
            <meta name="robots" content="noindex" />

            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css?family=Inter&display=swap"
            />
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css?family=Sora&display=swap"
            />
            <script async={false} src={withPrefix('FGTS.js')} type="text/javascript" />
          </Helmet>
          {element}
        </SnackBarProvider>
      </GoogleReCaptchaProvider>
    </Provider>
  )
}
